import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { API_BASE_URL } from '@core/injectors';
import { VersionDTO } from '@core/models';
import { Observable } from 'rxjs';

@Injectable()
export class VersionService {
  constructor(
    private readonly http: HttpClient,
    @Inject(API_BASE_URL) private readonly apiBaseUrl: string,
  ) {}

  getVersion(): Observable<VersionDTO[]> {
    return this.http.get<VersionDTO[]>(`${this.apiBaseUrl}/api/version/`);
  }
}
